import React, { useEffect, useRef, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Container, Row } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/images/logonew.png';
import './header.css';

const navLinks = [
  { path: '/', display: 'Home', end: true },
  { path: '/about', display: 'About' },
  { path: '/team', display: 'Team' },
  { path: '/services', display: 'Services' },
  { path: '/portfolio', display: 'Portfolio' },
  { path: '/contact', display: 'Contact us' },
];

const Header = () => {
  const navRef = useRef();
  const [isSticky, setIsSticky] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);

  const closeNavbar = () => {
    navRef.current?.classList.remove('responsive_nav');
    setIsNavOpen(false);
    document.body.style.overflow = 'auto';
  };

  const toggleNavbar = () => {
    const willOpen = !isNavOpen;
    navRef.current?.classList.toggle('responsive_nav', willOpen);
    setIsNavOpen(willOpen);
    document.body.style.overflow = willOpen ? 'hidden' : 'auto';
  };

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 80);
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isNavOpen) closeNavbar();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isNavOpen]);

  return (
    <header className={`header ${isSticky ? 'sticky__header' : ''}`}>
      <Container>
        <Row>
          <div className="nav__wrapper d-flex align-items-center justify-content-between">
            <div className="logo">
              <Link to="/" onClick={closeNavbar}>
                <img src={logo} alt="NeoApps logo" />
              </Link>
            </div>

            <div className="navigation" ref={navRef}>
              <ul className="menu d-flex align-items-center gap-5">
                {navLinks.map((item) => (
                  <li className="nav__item" key={item.path}>
                    <NavLink
                      to={item.path}
                      end={item.end}
                      className={({ isActive }) => (isActive ? 'active__link' : '')}
                      onClick={closeNavbar}
                    >
                      {item.display}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {!isNavOpen ? (
              <button
                type="button"
                className="nav-btn nav-menu-btn"
                onClick={toggleNavbar}
                aria-label="Open navigation menu"
                aria-expanded={false}
              >
                <FaBars />
              </button>
            ) : (
              <button
                type="button"
                className="nav-btn nav-close-btn"
                onClick={toggleNavbar}
                aria-label="Close navigation menu"
                aria-expanded={true}
              >
                <FaTimes />
              </button>
            )}
          </div>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
